export const barChartoptions = {
  chart: {
    type: 'column',
    events: {
      render: function () {
        //console.log('render');
      },
      redraw: function () {
        //console.log('redraw');
      },
    },
    backgroundColor: '#eef0f3',
    spacing: [10, 0, 0, 0],
  },
  credits: {
    mapText: '',
    mapTextFull: '',
    text: '',
  },
  exporting: {
    chartOptions: {
      title: {
        style: {
          'font-size': '16px',
          'font-weight': 'bold',
          'font-family': 'Arimo, Arial, sans-serif',
        },
      },
      chart: {
        spacing: [10, 10, 10, 10],
        marginBottom: 50,
      },
      credits: {
        mapText: '',
        mapTextFull: '',
        text: 'IWP – Swiss Inequality Database',
      },
    },
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },
  title: {
    text: '',
  },
  yAxis: [
    {
      title: {
        text: 'Einkommensanteil (in Prozent)',
        style: {
          color: '#21689d',
        },
      },
    },
    {
      title: {
        text: 'Umverteilung (in Prozentpunkten)',
        style: {
          color: '#e20000',
        },
      },
      opposite: true,
    },
  ],
  xAxis: {
    type: 'category',
    labels: {
      formatter: function () {
        var color = '#21689d';
        if (this.pos == 2) {
          color = '#e20000';
        }
        return `<span style="color:${color}">${this.value}</span>`;
      },
    },
  },
  series: [],
  tooltip: {
    backgroundColor: null,
    borderWidth: 0,
    shared: false,
    useHTML: true,
    footerFormat: '</div>',
    shadow: false,
  },
  loading: {
    hideDuration: 100,
    showDuration: 500,
  },
};
